module.exports = __webpack_public_path__ + "assets/kdfont.kdico.6bd65f2f.svg";